var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('RouterBreadcrumb',{staticClass:"main-content__router-breadcrumb"}),_c('router-view',{staticClass:"main-content__router-view"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }